// extracted by mini-css-extract-plugin
export var container = "UsageFlowSection-module--container--3EvdN";
export var title = "UsageFlowSection-module--title--ZkukT";
export var usageListContainer = "UsageFlowSection-module--usageListContainer--2_U_p";
export var usageItem = "UsageFlowSection-module--usageItem--vwNXx";
export var usageNo = "UsageFlowSection-module--usageNo--1R52Q";
export var usageTitle = "UsageFlowSection-module--usageTitle--2WKui";
export var usageBody = "UsageFlowSection-module--usageBody--2-xpb";
export var underlineIcon = "UsageFlowSection-module--underlineIcon--3I6RB";